import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { List, Map } from 'immutable';
import {
  DocumentTypesEnum,
  ICopyDocumentOptions,
} from '../../../document-data/document-data.data';
import { Document } from '../../../document-data/document.model';
import { ISelectOption } from '../../../form-master/components/select-field/select-field.interface';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';

@Injectable()
export class CopyDocumentDialogBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    COPY_AS: 'copyAs',
    COPY_CLIENT: 'copyClient',
    COPY_ITEMS: 'copyItems',
    COPY_ATTACHMENTS: 'copyAttachments',
    COPY_TAXES: 'copyTaxes',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _translateService: TranslateService
  ) {}

  buildForm(defaultCopyAs: DocumentTypesEnum): FormGroup {
    const formKeys = this.FORM_KEYS;

    return this._formBuilder.group({
      [formKeys.COPY_AS]: [defaultCopyAs],
      [formKeys.COPY_CLIENT]: [true],
      [formKeys.COPY_ITEMS]: [true],
      [formKeys.COPY_ATTACHMENTS]: [true],
      [formKeys.COPY_TAXES]: [true],
    });
  }

  buildSelectOptions(
    disabledDocumentTypes: List<DocumentTypesEnum>
  ): List<ISelectOption> {
    return List([
      {
        key: this._translateService.instant('DOCUMENT.TYPE.INVOICE'),
        value: DocumentTypesEnum.invoice,
        disabled: disabledDocumentTypes.some(
          (documentType: DocumentTypesEnum) =>
            documentType === DocumentTypesEnum.invoice
        ),
      },
      {
        key: this._translateService.instant('DOCUMENT.TYPE.ESTIMATE'),
        value: DocumentTypesEnum.estimate,
        disabled: disabledDocumentTypes.some(
          (documentType: DocumentTypesEnum) =>
            documentType === DocumentTypesEnum.estimate
        ),
      },
      {
        key: this._translateService.instant('DOCUMENT.TYPE.CREDIT_MEMO'),
        value: DocumentTypesEnum.credit_memo,
        disabled: disabledDocumentTypes.some(
          (documentType: DocumentTypesEnum) =>
            documentType === DocumentTypesEnum.credit_memo
        ),
      },
      {
        key: this._translateService.instant('DOCUMENT.TYPE.PURCHASE_ORDER'),
        value: DocumentTypesEnum.purchase_order,
        disabled: disabledDocumentTypes.some(
          (documentType: DocumentTypesEnum) =>
            documentType === DocumentTypesEnum.purchase_order
        ),
      },
    ]);
  }

  buildCopyOptions(
    copyInfo: Map<string, any>,
    sourceDocument: Document
  ): ICopyDocumentOptions {
    const formKeys = this.FORM_KEYS;

    return {
      copyAs: copyInfo.get(
        formKeys.COPY_AS,
        DocumentTypesEnum.invoice
      ) as DocumentTypesEnum,
      copyClient: copyInfo.get(formKeys.COPY_CLIENT, true),
      copyItems: copyInfo.get(formKeys.COPY_ITEMS, true),
      copyAttachments: copyInfo.get(formKeys.COPY_ATTACHMENTS, true),
      copyTaxes: copyInfo.get(formKeys.COPY_TAXES, true),
      sourceDocument,
    };
  }
}
